import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AssetsLiabilitiesPartTwoFormData } from "@app/components/Individual/assetsLiabilities/PartTwo";
import { AssetsLiabilitiesPartThreeFormData } from "@app/components/Individual/assetsLiabilities/PartThree";
import { AssetsLiabilitiesPartFourFormData } from "@app/components/Individual/assetsLiabilities/PartFour";

interface Propertydetail {
  detail: string;
  value: string;
}
interface superannuationInter {
  nameOfFund: string;
  value: string;
}
interface Driverlicenseimages {
  frontImage?: string;
  backImage?: string;
}
interface VisaAndPassportimages {
  passportImage?: string;
  visaImage?: string;
}

interface StepsDataTypes {
  assetLiabilityId?: string;
  formOne?: {
    realState: Propertydetail[];
    superannuation: superannuationInter[];
    realeStateType: string;
    superannuationType: string;
  };
  formTwo?: AssetsLiabilitiesPartTwoFormData;
  formThree?: AssetsLiabilitiesPartThreeFormData;
  formFour?: AssetsLiabilitiesPartFourFormData;
  passportImage?: string;
  IsvalidPassport?: boolean;
  driverlicenseimages?: Driverlicenseimages;
  bankStatement?: string[];
  bankStatementTerms?: boolean;
  visaAndPassportimages?: VisaAndPassportimages;
  isValidPassportImages?: Driverlicenseimages;
}

interface StepState {
  currentStep: number;
  stepsData: StepsDataTypes;
}
const initialState: StepState = {
  currentStep: 0,
  stepsData: {
    assetLiabilityId: "",
    formOne: {
      realState: [],
      superannuation: [],
      realeStateType: "",
      superannuationType: "",
    },
    formTwo: {
      savingAndInvestmentsType: "",
      otherAssetsType: "",
      savingAndInvestments: [],
      otherAssets: [],
    },
    formThree: {
      existingMortgage: [],
      carLoan: [],
      existingMortgageType: "",
      carloanType: "",
    },
    formFour: {
      otherliabilitiesType: "",
      otherLiabilities: [],
    },
    passportImage: "",
    bankStatement: [],
    driverlicenseimages: {
      frontImage: "",
      backImage: "",
    },
    visaAndPassportimages: {
      passportImage: undefined,
      visaImage: undefined,
    },
  },
};
export const assetsLiabilities = createSlice({
  name: "assetsLiabilities",
  initialState,
  reducers: {
    nextStep: (state) => {
      state.currentStep += 1;
    },
    prevStep: (state) => {
      if (state.currentStep >= 1) state.currentStep -= 1;
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    addStepsData: (state, action: PayloadAction<StepsDataTypes>) => {
      state.stepsData = { ...state.stepsData, ...action.payload };
    },
    resetStepsData: (state) => {
      state.stepsData = {};
      state.currentStep = 1;
    },
  },
});

export const { nextStep, prevStep, setStep, addStepsData, resetStepsData } =
  assetsLiabilities.actions;

export default assetsLiabilities.reducer;
